import React, { useState, useEffect } from "react"
import { db } from "../../utils/firebase"
import "./deleted-enquiries.scss"

// UI components
import Tile from "../../components/structure/tile/tile"
import Table from "../../components/structure/table/table"
import Title from "../../components/structure/title/title"
import DeletedEnquiry from "./_components/enquiry"

// Functional component to return the deleted enquiries and blame
export default function DeletedEnquiries() {
	const [loading, setLoading] = useState(true)
	const [enquiries, setEnquiries] = useState([])

	// On component load
	useEffect(() => {
		// Fetch the latest 200 deleted enquiries
		db.collection("enquiries_removed")
			.orderBy("created", "desc")
			.limit(1000)
			.get()
			.then((querySnapshot) => {
				const enquiries = []
				querySnapshot.forEach((doc) => {
					enquiries.push({ id: doc.id, ...doc.data() })
				})
				setEnquiries(enquiries)
				setLoading(false)
			})
	}, [])

	return (
		<Tile fullPage={true}>
			<Title className="flex">
				<h1>Deleted Enquiries</h1>
			</Title>

			<Table
				className="enquiries-table"
				headings={["Site", "Client Name", "Location/Event", "Date from", "Follow up", "Group size", "Removed By", "Removed On", ""]}>
				{loading && (
					<tr>
						<td colSpan="9">Loading...</td>
					</tr>
				)}

				{!loading &&
					enquiries.map((enquiry, index) => (
						<DeletedEnquiry
							key={index}
							enquiry={enquiry}
						/>
					))}
			</Table>
		</Tile>
	)
}
